import React, { useState } from "react";
import "./LoginSignup.css";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { sendSMSOtp, verifySMSOtp, resetSMSOtpState } from "../../utils/smsOtp";
import {
  clearPendingAuthRedirect,
  getPendingAuthRedirect,
} from "../../utils/authRedirect";

const OTPVerification = () => {
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [isResending, setIsResending] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const navigate = useNavigate();
  const { refreshUser } = useAuth();

  const phone = localStorage.getItem("pendingPhone");
  const purpose = localStorage.getItem("pendingOtpPurpose") || "register";
  const otpMethod = localStorage.getItem("pendingOtpMethod") || "sms";

  const clearPendingAuth = () => {
    localStorage.removeItem("pendingEmail");
    localStorage.removeItem("pendingPhone");
    localStorage.removeItem("pendingOtpPurpose");
    localStorage.removeItem("pendingOtpMethod");
    localStorage.removeItem("pendingRegistrationData");
    clearPendingAuthRedirect();
    resetSMSOtpState();
  };

  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setIsVerifying(true);

    if (!otp || otp.trim() === "") {
      setError("Please enter the OTP");
      setIsVerifying(false);
      return;
    }

    try {
      let res;

      if (!phone || otpMethod !== "sms") {
        throw new Error("Session expired. Please start again.");
      }

      let registrationData = null;

      if (purpose === "register") {
        registrationData = JSON.parse(localStorage.getItem("pendingRegistrationData") || "null");

        if (!registrationData) {
          throw new Error("Registration details expired. Please register again.");
        }
      }

      res = await verifySMSOtp({
        phone,
        otp: otp.trim(),
        purpose,
        registrationData,
      });

      if (res.data.success) {
        const redirectPath = getPendingAuthRedirect();
        clearPendingAuth();
        await refreshUser();
        navigate(redirectPath || "/");
      }
    } catch (err) {
      setError(err.response?.data?.message || err.message || "OTP verification failed");
    } finally {
      setIsVerifying(false);
    }
  };

  const handleResendOTP = async () => {
    if (!phone || otpMethod !== "sms") {
      setError("Session expired. Please start again.");
      return;
    }

    setIsResending(true);
    setError("");
    setMessage("");

    try {
      await sendSMSOtp(phone, purpose);
      setMessage("OTP resent successfully to your phone");
    } catch (err) {
      setError(err.response?.data?.message || err.message || "Failed to resend OTP");
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2 className="auth-title">Verify OTP</h2>
        <p style={{ textAlign: "center", marginBottom: "20px", fontSize: "14px", color: "#666" }}>
          Enter the OTP sent to your phone number <br />
          <strong>{phone ? `+91${phone}` : ""}</strong>
        </p>
        <form onSubmit={handleVerifyOTP}>
          <input
            type="text"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => {
              setOtp(e.target.value.replace(/\D/g, "").slice(0, 6));
              setError("");
              setMessage("");
            }}
            maxLength="6"
            required
          />
          {error && <p className="auth-error">{error}</p>}
          {message && <p className="auth-info-message">{message}</p>}
          <button type="submit" className="auth-button" disabled={isVerifying}>
            {isVerifying ? "Verifying..." : "Verify"}
          </button>
        </form>
        <div className="auth-footer">
          <p>
            Didn&apos;t receive the OTP?{" "}
            <span onClick={handleResendOTP}>
              {isResending ? "Resending..." : "Resend OTP"}
            </span>
          </p>
          <p>
            Want to change details?{" "}
            <span onClick={() => navigate(purpose === "login" ? "/login" : "/register")}>
              Go Back
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default OTPVerification;
